import type {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';

export interface SharedPageContextService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<PageContextServiceV1>;
}

export interface PageContextServiceV1 {
  readonly getPageContext: () => PageContext;
  readonly subscribe: (listener: PageContextListenerV1) => () => void;
}

export interface PageContext {
  readonly isCustomizerFeatureAppDefined: boolean;
}

export type PageContextListenerV1 = (newPageContext: PageContext) => void;

export interface PageContextServiceOptions {
  readonly initialPageContext: PageContext;
  readonly subscribe: (listener: PageContextListenerV1) => void;
}

export function definePageContextService(
  options: PageContextServiceOptions,
): FeatureServiceProviderDefinition<SharedPageContextService> {
  const {initialPageContext, subscribe} = options;

  return {
    id: `page-context-service`,

    create: () => {
      const listeners = new Set<PageContextListenerV1>();
      let pageContext = initialPageContext;

      subscribe((newPageContext) => {
        pageContext = newPageContext;

        for (const listener of listeners) {
          listener(pageContext);
        }
      });

      return {
        '1.0.0': () => {
          return {
            featureService: {
              getPageContext: () => pageContext,

              subscribe: (listener) => {
                listeners.add(listener);

                return () => {
                  listeners.delete(listener);
                };
              },
            },
          };
        },
      };
    },
  };
}
